var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',[_vm._v("\n    Loading...\n  ")]):_vm._e(),(_vm.loaded)?_vm._t("default"):_vm._e(),(_vm.loaded)?_vm._t("fulfilled"):_vm._e(),(_vm.error)?_c('div',[_vm._v("Error: "+_vm._s(_vm.error.response.data.message))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }